import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Company {
  companyId: string;
  name: string;
  usageCount: number;
}

interface CompanyState {
  currentCompany: Company | null;
  loading: boolean;
  error: string | null;
}

const initialState: CompanyState = {
  currentCompany: null,
  loading: false,
  error: null,
};

export const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    fetchCompanyStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchCompanySuccess: (state, action: PayloadAction<Company>) => {
      state.currentCompany = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchCompanyFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearCompany: (state) => {
      state.currentCompany = null;
    },
  },
});

export const {
  fetchCompanyStart,
  fetchCompanySuccess,
  fetchCompanyFailure,
  clearCompany,
} = companySlice.actions;

export default companySlice.reducer;
